// Copyright (c) 2020 WiseTime. All rights reserved.

import React from "react"
import { Slide, ToastContainer } from "react-toastify"
import "react-toastify/dist/ReactToastify.css"

const SnackBar = (): React.ReactElement<unknown> => (
  <ToastContainer
    autoClose={5000}
    transition={Slide}
    position="top-center"
    hideProgressBar
    newestOnTop={false}
    closeOnClick={true}
    closeButton={false}
    rtl={false}
    pauseOnFocusLoss={false}
    draggable={true}
    pauseOnHover
  />
)

export default SnackBar
